import MobilePicturesCarousel from "./MobilePicturesCarousel";


export default function MobilePicturesPage(){
    return(
            <MobilePicturesCarousel />
           )
}